const MIME_BY_EXTENSION: Record<string, { mime: string; extensions: string[] }> = {
  png: { mime: "image/png", extensions: [".png"] },
  jpg: { mime: "image/jpeg", extensions: [".jpg", ".jpeg"] },
  jpeg: { mime: "image/jpeg", extensions: [".jpg", ".jpeg"] },
  gif: { mime: "image/gif", extensions: [".gif"] },
  webp: { mime: "image/webp", extensions: [".webp"] },
  svg: { mime: "image/svg+xml", extensions: [".svg"] },
  pdf: { mime: "application/pdf", extensions: [".pdf"] },
  doc: { mime: "application/msword", extensions: [".doc"] },
  docx: {
    mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    extensions: [".docx"],
  },
};

/**
 * Turns a list of file extensions (e.g. `["png", "jpg"]`) into the `accept` map expected by
 * react-dropzone. Returns `undefined` when nothing is recognised, so the dropzone stays unrestricted.
 */
export const buildAccept = (
  acceptedTypes?: string[],
): Record<string, string[]> | undefined => {
  const accept: Record<string, string[]> = {};

  acceptedTypes?.forEach((type) => {
    const entry = MIME_BY_EXTENSION[type.toLowerCase().replace(/^\./, "")];
    if (!entry) return;

    accept[entry.mime] = Array.from(
      new Set([...(accept[entry.mime] ?? []), ...entry.extensions]),
    );
  });

  return Object.keys(accept).length > 0 ? accept : undefined;
};
